import EditOutlined from '@ant-design/icons/lib/icons/EditOutlined'
import { Button, Col, DatePicker, Form, Input, Modal, Row, Select, Space } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import moment from 'moment'
import { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { baseAxiosComplete, baseAxiosNoInfo } from '../../../tool/axios'

const { Option } = Select

interface baby {
    id: string
    nick_name: string
    sex: number
    born_date: string
    height: number
    weight: number
    reserve_list: {
        check_in_id: string //入住id，“入住客户管理-按条件查询列表（分页）”接口返回的check_in_id字段
        service_type_id: number //服务类型 1满月派对 2剃胎发 3宝宝摄影
        reserve_date: string //预约日期
    }[]
}

const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 14 }
}
interface Prop {
    storeID?: string
    onFinish?: ()=> void
}
export default function (prop: Prop) {

    const param: { id: string } = useParams()
    const [data, setData] = useState<baby>()
    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const getClientInfo = () => {
        baseAxiosNoInfo('/keeper/check_in/detail/baby_info', {
            params: {
                check_in_id: param.id
            }
        }).then((res: any) => {
            res && setData(res)
        })
    }

    const changeClientInfo = (values: any) => {
        baseAxiosComplete.post('/keeper/check_in/detail/update_baby_info', {
            check_in_id:param.id,
            id: data?.id,
            nick_name: values.nick_name,
            sex: values.sex,
            born_date: values.born_date.format('YYYY-MM-DD'),
            height: values.height,
            weight: values.weight
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                getClientInfo()
            }
        })
    }

    useEffect(() => {
        getClientInfo()
    }, [])

    return (<div className="modules">

        <Modal title="编辑宝宝信息" visible={visible} onCancel={() => { setVisible(false) }} footer={false}>
            <Form  {...formItemLayout} form={form} onFinish={changeClientInfo} >
                <Form.Item label="宝宝昵称" name="nick_name">
                    <Input />
                </Form.Item>
                <Form.Item label="宝宝性别" name="sex" rules={[{ required: true, message: '必须选择宝宝性别' }]}>
                    <Select>
                        <Option value={0} key={0}>男</Option>
                        <Option value={1} key={1}>女</Option>
                    </Select>
                </Form.Item>
                <Form.Item label="宝宝生日" name="born_date" rules={[{ required: true, message: '必须选择宝宝生日' }]}>
                    <DatePicker />
                </Form.Item>
                <Form.Item label="宝宝身高(cm)" name="height" >
                    <Input />
                </Form.Item>
                <Form.Item label="体重(kg)" name="weight" >
                    <Input />
                </Form.Item>
                <Form.Item wrapperCol={{ span: 12, offset: 7 }}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>
        <div className="top clear">
            <h3 className="fl"><span className="fl">宝宝信息</span></h3>
            {/* <div className="fr editbtn"  onClick={() => {
                form.setFieldsValue({
                    nick_name: data?.nick_name,
                    sex: data?.sex,
                    born_date: moment(data?.born_date),
                    height: data?.height,
                    weight: data?.weight
                })
                setVisible(true)
            }}><EditOutlined style={{marginRight:10}} />编辑宝宝信息</div> */}
        </div>
        <div className="clear" style={{marginTop:20}}>
            <Row style={{width:'100%'}}>
                <Col span={5}>
                    <div>
                        <Space>
                            <p className="label">宝宝昵称：</p>
                            <p className='right-text'>{data?.nick_name || '--'}</p>
                        </Space>
                    </div>
                </Col>
                <Col span={4}>
                    <div>
                        <Space>
                            <p className="label">性别：</p>
                            <p className='right-text'>{data?.sex === 0 ? '男' : '女'}</p>
                        </Space>
                    </div>
                </Col>
                <Col span={4}>
                    <div>
                        <Space>
                            <p className="label">生日：</p>
                            <p className='right-text'>{data?.born_date || '--'}</p>
                        </Space>
                    </div>
                </Col>
                <Col span={5}>
                    <div>
                        <Space>
                            <p className="label">身高(cm)：</p>
                            <p className='right-text'>{data?.height || '--'}</p>
                        </Space>
                    </div>
                </Col>
                <Col span={5}>
                    <div>
                        <Space>
                            <p className="label">体重(kg)：</p>
                            <p className='right-text'>{data?.weight || '--'}</p>
                        </Space>
                    </div>
                </Col>
            </Row>


            {data?.reserve_list.map(el=><Row className="clear" style={{width:'100%'}}>
                <Col span={4}>
                    <div>
                        <Space style={{color:'red'}}>
                            <p className='right-text'>服务类型</p>
                            <p style={{color:'red'}}>{el?.service_type_id === 1 && '漫画派对' || el?.service_type_id === 2&& '剃胎发' || el?.service_type_id === 3 && '宝宝摄影'}</p>
                        </Space>
                    </div>
                </Col>
                <Col span={4}>
                    <div>
                        <Space style={{color:'red'}}>
                            <p className='right-text'>预约日期：</p>
                            <p style={{color:'red'}}>{el?.reserve_date}</p>
                        </Space>
                    </div>
                </Col>
            </Row>)}
        </div>
    </div>)
}